import { ToggleSwitch } from "@zapier/design-system";
import { ToggleContainer } from "../ToggleContainer";

export function LoadingToggle() {
  return (
    <ToggleContainer
      tooltipContent="Loading asset status..."
      ariaLabel="Asset status is loading"
    >
      <ToggleSwitch isLoading={true} disabled showDisabledTooltip={false} />
    </ToggleContainer>
  );
}
